<template>
	<img class="prod-line" v-if="props.line === 'E-Brake'" src="@/images/logos/eBrake.png" alt="E-Brake">
	<img class="prod-line" v-else-if="props.line === 'H-Brake'" src="@/images/logos/hBrake.png" alt="H-Brake">
	<img class="prod-line" v-else-if="props.line === 'H-BrakeHD'" src="@/images/logos/hBrakeHD.png" alt="H-BrakeHD">
	<img class="prod-line" v-else-if="props.line === 'H-iBrake'" src="@/images/logos/hiBrake.png" alt="H-iBrake">
	<img class="prod-line" v-else-if="props.line === 'MiniCell'" src="@/images/logos/miniCell.png" alt="Mini Cell">
	<img class="prod-line" v-else-if="props.line === 'MultiCell'" src="@/images/logos/multiCell.png" alt="Multi Cell">
	<img class="prod-line" v-else-if="props.line === 'M-Shear'" src="@/images/logos/mShear.png" alt="M-Shear">
	<img class="prod-line" v-else-if="props.line === 'R-Brake'" src="@/images/logos/rBrake.png" alt="R-Brake">
	<img class="prod-line" v-else-if="props.line === 'RoboMate'" src="@/images/logos/roboMate.png" alt="Robo Mate">
	<img class="prod-line" v-else-if="props.line === 'ToolMate'" src="@/images/logos/toolMate.png" alt="Tool Mate">
	<img class="prod-line" v-else-if="props.line === 'Software'" src="@/images/logos/software.png" alt="Software">
	<img class="prod-line" v-else-if="props.line === 'E-Control'" src="@/images/logos/eControl.png" alt="E-Control">
	<img class="prod-line" v-else-if="props.line === 'ASC-Control'" src="@/images/logos/ascControl.png" alt="ASC-Control">
	<img class="prod-line" v-else-if="props.line === 'RoboBend'" src="@/images/logos/roboBend.png" alt="RoboBend">
	<img class="prod-line" v-else-if="props.line === 'AutoPOL'" src="@/images/logos/autoPOL.png" alt="AutoPOL">
</template>

<script setup>
const props = defineProps({
	line: {
		type: String,
		required: true,
	},
})
</script>
